export const DOWNLOAD_BLOB_FILE = "DOWNLOAD_BLOB_FILE";